import { useRecoilState } from 'recoil'

import { BooleanAtom } from '../recoil/atoms'

function useSidebar() {
  const [opened, setOpened] = useRecoilState(BooleanAtom('Sidebar'))

  const toggle = () => {
    setOpened(!opened)
  }

  const close = () => {
    setOpened(false)
  }

  return { opened, toggle, close }
}

export default useSidebar
